import { ColDef } from 'ag-grid-enterprise';
import applicationConstants from '../../../Core/Utility/ApplicationConstants';
import { PresentationTemplateModel } from '../../../Generated/Raven-Demeter';
import formattingService from '../../Services/Formatting/FormattingService';
import languageService from '../../Services/Language/LanguageService';
import { translationKeys } from '../../Services/Language/TranslationDefinitions';

export type RendererParameters = {
    data: PresentationTemplateModel;
};

export const columnDefinitions: ColDef[] = [
    {
        field: 'name',
        headerValueGetter: () => languageService.translate(translationKeys.presentationTemplates.fields.templateName),
        minWidth: 100,
    },
    {
        field: 'createdByDisplayName',
        headerValueGetter: () => languageService.translate(translationKeys.presentationTemplates.fields.createdBy),
        minWidth: 200,
    },
    {
        field: 'lastRunAt',
        headerValueGetter: () => languageService.translate(translationKeys.presentationTemplates.fields.lastRunAt),
        cellRenderer: (parameters: RendererParameters) => {
            if (parameters.data.lastRunAt) {
                return formattingService.toLongDateAndTimeFormat(new Date(parameters.data.lastRunAt));
            }
            return applicationConstants.TablePlaceholderZeroOrEmpty;
        },
        minWidth: 100,
    },
    {
        field: 'actions',
        headerValueGetter: () => languageService.translate(translationKeys.words.actions),
        maxWidth: 200,
        width: 200,
        minWidth: 200,
        pinned: 'right',
        lockPinned: true,
    },
];

export const defaultColumnDefinition = {
    resizable: true,
    autoHeaderHeight: true,
    wrapHeaderText: true,
    flex: 1,
    rowDragManaged: true,
    animateRows: true,
    wrapText: true,
    enableCellChangeFlash: true,
    headerClass: 'ag-header-cell-flex-start',
    sortable: false,
};
